import { useContext } from 'react';
import { NextPage } from 'next';;
import getConfig from 'next/config';

import LocaleContext from 'components/context/Locale';
import ButtonLink from 'components/layout/ButtonLink';
import Head from 'components/layout/Head';
import LayoutContainer from 'components/layout/LayoutContainer';
import LayoutCompany from 'components/modules/public/layouts/Company';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPage404: NextPage<Props> = () => {
    const localeContext = useContext(LocaleContext);
    const data = localeContext?.translations?.companyPolicy;
    const { publicRuntimeConfig } = getConfig();
    return (
        <>
            <Head {...data.meta} />
            <LayoutCompany>
                <StyledComponent className="public-page-company-policy">
                    <LayoutContainer {...data.content.layoutContainerProps}>
                        <p className="headline">
                            {data.content.title}
                        </p>
                        <p className="txt">
                            Aktualny regulamin obowiązuje od dnia 4 marca 2024 r.
                        </p>
                       
                        <ButtonLink
                            href="https://docs.google.com/gview?embedded=true&url=https://praca50.plus/pdf/regulamin-pracodawcy-04.03.2024.pdf"
                            label="Zobacz regulamin"
                            style='primary'
                            size="medium"
                            variant="primary"
                            layout="wide"
                        />

                        <p className="txt-small">
                            Regulamin obowiązujący od 13 grudnia 2022 r. do 3 marca 2024 r. znajdziesz <a className="link" target="_blank" href="https://praca50.plus/pdf/regulamin-pracodawcy-13.12.2022.pdf">tutaj</a>.
                        </p>
                        <p className="txt-small">
                            Regulamin obowiązujący do 12 grudnia 2022 r. znajdziesz  <a className="link" target="_blank" href="https://praca50.plus/pdf/regulamin-pracodawcy-12.12.2022.pdf">tutaj</a>.
                        </p>
                       
                    </LayoutContainer>
                </StyledComponent>
            </LayoutCompany>
        </>
    );
};

export default PublicPage404;
